// Official Equestrian Partners assets (provided by client) served from /public/assets.
export const MEDIA = {
  heroDesktop: "/assets/hero-desktop.png",
  heroMobile: "/assets/hero-mobile.png",
  statement: "/assets/hero-mobile.png",
  expertise: "/assets/ventaja.png",
  methodBackdrop: "/assets/finalcta.png",
  finalCta: "/assets/finalcta.png",
  opportunities: {
    performance: "/assets/opp-performance.png",
    broadcast: "/assets/opp-broadcast.png",
    stable: "/assets/opp-stable.png",
    commerce: "/assets/opp-commerce.png",
  },
};

export const LOGO = {
  horizontalBlack: "/assets/logo-horizontal-black.png",
  horizontalWhite: "/assets/logo-horizontal-white.png",
  iconBlack: "/assets/logo-icon-black.png",
  iconWhite: "/assets/logo-icon-white.png",
};

export const INSTAGRAM_URL = "https://www.instagram.com/equestrian_partners";
export const CONTACT_EMAIL = "contact@equestrianpartners.net";
export const SESSION_PRICE = "299 €";
